module.exports = __webpack_public_path__ + "img/GTC-D-front.c652777b.jpg";